import React from "react";

import { graphql } from "gatsby";

import LearnArticleEmbedComponent from "../../components/learnArticleEmbed/learnArticleEmbed";
import KontentItemImage from "../kontentItemImage";

interface DonorArticleEmbedProps {
  data: Queries.kontent_item_article_donor_area;
}

const DonorArticleEmbed: React.FC<DonorArticleEmbedProps> = ({ data }) => {
  if (!data || !data.elements) {
    return null;
  }

  const elements = data.elements!;

  return (
    <LearnArticleEmbedComponent
      headline={elements.headline?.value || ""}
      border
      href={data.id}
      image={(
        <KontentItemImage
          data={elements.hero_image?.value?.[0] as Queries.kontent_item_image}
          width={78}
          aspectRatio={1}
        />
      )}
    />
  );
};

export const query = graphql`
  fragment DonorArticleEmbed on kontent_item_article_donor_area {
    id
    system {
      codename
    }
    elements {
      headline {
        value
      }
      hero_image {
        value {
          ...KontentItemImage
        }
      }
    }
  }
`;

export default DonorArticleEmbed;
